import React from "react"

export default function HotspotSvg() {
  return (
    <svg width="1110" height="624" viewBox="0 0 1110 624" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4073_32864)">
        <rect width="1110" height="624" fill="white" />
        <rect opacity="0.67" x="-105" y="-159" width="1320" height="592" fill="#E7F0FF" />
        <rect opacity="0.6" x="-202" y="437" width="1319" height="233" fill="#BDC5D4" />
        <rect x="-105" y="502.906" width="1319" height="168.398" fill="#C0C0C0" />
        <path d="M-88.5039 558.58H1262.8" stroke="white" strokeWidth="4.12402" strokeLinejoin="round" strokeDasharray="35.74 35.74" />
        <path d="M1215 323.944L-105 50V437H1215V323.944Z" fill="#E5F0FF" />
        <path
          d="M1061.65 326.561L1063.42 381.574V436.587H1056.68V381.574L1058.37 326.561H1061.65Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M1059.82 327.96C1060.86 327.96 1061.71 327.115 1061.71 326.071C1061.71 325.028 1060.86 324.182 1059.82 324.182C1058.78 324.182 1057.93 325.028 1057.93 326.071C1057.93 327.115 1058.78 327.96 1059.82 327.96Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M1058.86 327.698C1056.97 329.077 1051.49 334.829 1049.73 335.821C1047.97 336.814 1021.01 352.118 1020.35 352.499C1019.69 352.881 1019.55 352.336 1019.76 352.159C1025.15 347.833 1057.93 326.025 1057.93 326.025L1058.86 327.697L1058.86 327.698Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M1060.95 327.588C1060.95 327.588 1096.05 345.049 1102.48 347.577C1102.74 347.672 1103.14 347.279 1102.48 346.897C1101.82 346.518 1075.15 330.732 1073.41 329.697C1071.67 328.662 1063.81 326.671 1061.67 325.716L1060.95 327.588H1060.95Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M1058.68 324.559C1058.44 322.232 1056.2 314.343 1056.23 312.32C1056.25 310.297 1056.53 279.293 1056.53 278.533C1056.53 277.774 1057.07 277.924 1057.12 278.196C1058.16 285.031 1060.66 324.379 1060.66 324.379L1058.69 324.559H1058.68Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <rect x="1056.47" y="409.862" width="6.73577" height="26.8873" fill="#060e4d" />
        <path
          d="M1106.31 257.332H961.629C959.796 253.208 958.055 243.723 965.753 238.774C973.451 233.825 979.5 239.232 981.562 242.554C978.927 235.337 978.469 220.491 997.714 218.841C994.163 212.77 990.497 199.321 1004.24 194.097C1021.43 187.567 1050.64 196.503 1041.7 223.996C1046.74 217.008 1059.23 206.194 1068.85 218.841C1077.21 229.822 1076.67 236.416 1074.88 239.162C1078.23 235.682 1085.21 231.451 1092.22 236.712C1099.92 242.485 1098.41 246.907 1096.69 248.397C1099.9 247.938 1106.31 249.084 1106.31 257.332Z"
          fill="white"
        />
        <path
          d="M618.093 261.804H492.997H482C482 252.07 490.706 251.085 495.059 251.81C494.945 249.347 497.19 243.64 507.088 240.512C516.985 237.383 522.667 243.554 524.271 247.03C524.042 244.133 525.027 237.905 530.801 236.167C536.575 234.429 542.371 238.339 544.548 240.512C546.381 235.008 554.995 224 574.791 224C594.586 224 600.337 239.278 601.597 245.651C612.938 240.512 620.842 245.307 618.093 261.804Z"
          fill="white"
        />
        <path
          d="M113.598 211H292.635H308C308 191.432 295.836 189.452 289.755 190.908C289.915 185.958 286.778 174.485 272.95 168.195C259.121 161.906 251.183 174.31 248.942 181.299C249.262 175.475 247.886 162.954 239.82 159.46C231.753 155.966 223.655 163.828 220.614 168.195C218.053 157.13 206.017 135 178.361 135C150.705 135 142.671 165.715 140.91 178.527C125.065 168.195 109.757 177.836 113.598 211Z"
          fill="white"
        />
        <path
          d="M-25.0002 305.99H72.2336C73.4654 303.21 74.6356 296.818 69.4621 293.483C64.2886 290.148 60.2237 293.792 58.8379 296.031C60.6086 291.167 60.9165 281.162 47.9828 280.05C50.3694 275.958 52.8329 266.895 43.5946 263.374C32.0466 258.974 12.4151 264.996 18.42 283.524C15.0326 278.815 6.64113 271.527 0.174278 280.05C-5.44062 287.45 -5.07761 291.894 -3.87669 293.745C-6.12829 291.4 -10.8168 288.548 -15.5309 292.093C-20.7044 295.984 -19.6882 298.964 -18.5334 299.968C-20.689 299.659 -25.0002 300.431 -25.0002 305.99Z"
          fill="white"
        />
        <path
          d="M517.089 209.642L539.945 200.825L502.152 180.352L493.156 183.222L517.089 209.642Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M508.348 214.913L508.083 214.081C507.828 213.284 508.242 212.427 509.024 212.131L558.646 193.332L688.281 151.971C705.887 146.354 715.264 149.027 718.089 151.266C718.288 151.424 718.507 151.552 718.751 151.623C722.084 152.589 727.824 154.7 726.743 156.22C725.339 158.192 720.392 161.804 716.848 163.443C714.013 164.754 708.488 166.449 706.08 167.133L576.252 208.555C572.547 209.737 568.726 210.516 564.854 210.878L509.994 216.002C509.258 216.07 508.573 215.617 508.348 214.913Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="555.242"
          y="201.788"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 555.242 201.788)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="558.012"
          y="200.904"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 558.012 200.904)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="560.777"
          y="200.021"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 560.777 200.021)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="563.547"
          y="199.138"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 563.547 199.138)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="566.316"
          y="198.255"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 566.316 198.255)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="569.082"
          y="197.372"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 569.082 197.372)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="571.852"
          y="196.489"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 571.852 196.489)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="574.621"
          y="195.605"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 574.621 195.605)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="577.387"
          y="194.722"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 577.387 194.722)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="580.156"
          y="193.839"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 580.156 193.839)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="582.922"
          y="192.956"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 582.922 192.956)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="585.691"
          y="192.073"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 585.691 192.073)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="588.461"
          y="191.189"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 588.461 191.189)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="591.227"
          y="190.307"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 591.227 190.307)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="593.996"
          y="189.423"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 593.996 189.423)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="596.762"
          y="188.54"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 596.762 188.54)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="599.531"
          y="187.657"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 599.531 187.657)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="602.297"
          y="186.774"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 602.297 186.774)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="605.066"
          y="185.891"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 605.066 185.891)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="607.836"
          y="185.008"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 607.836 185.008)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="610.602"
          y="184.125"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 610.602 184.125)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="613.371"
          y="183.241"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 613.371 183.241)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="616.141"
          y="182.358"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 616.141 182.358)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="618.906"
          y="181.475"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 618.906 181.475)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="621.676"
          y="180.592"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 621.676 180.592)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="624.441"
          y="179.708"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 624.441 179.708)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="627.211"
          y="178.825"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 627.211 178.825)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="629.98"
          y="177.942"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 629.98 177.942)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="632.746"
          y="177.059"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 632.746 177.059)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="635.516"
          y="176.176"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 635.516 176.176)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="638.281"
          y="175.293"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 638.281 175.293)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="641.051"
          y="174.41"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 641.051 174.41)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="643.816"
          y="173.527"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 643.816 173.527)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="646.59"
          y="172.644"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 646.59 172.644)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="649.355"
          y="171.76"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 649.355 171.76)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="652.121"
          y="170.877"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 652.121 170.877)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="654.895"
          y="169.994"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 654.895 169.994)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="657.66"
          y="169.111"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 657.66 169.111)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="670.117"
          y="165.137"
          width="1.45274"
          height="1.93699"
          transform="rotate(-17.6956 670.117 165.137)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="672.887"
          y="164.254"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 672.887 164.254)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="675.652"
          y="163.371"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 675.652 163.371)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="678.422"
          y="162.488"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 678.422 162.488)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="681.191"
          y="161.604"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 681.191 161.604)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="683.957"
          y="160.721"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 683.957 160.721)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="686.723"
          y="159.838"
          width="1.45275"
          height="1.93699"
          transform="rotate(-17.6956 686.723 159.838)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="689.496"
          y="158.955"
          width="1.45273"
          height="1.93699"
          transform="rotate(-17.6956 689.496 158.955)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="692.262"
          y="158.072"
          width="1.45273"
          height="1.93699"
          transform="rotate(-17.6956 692.262 158.072)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M712.183 150.953L715.336 149.947C717.014 150.428 718.252 151.388 718.683 151.675L713.089 153.674C712.53 153.874 711.917 153.57 711.737 153.005L711.502 152.271C711.326 151.719 711.631 151.129 712.183 150.953Z"
          fill="#060e4d"
          fillOpacity="0.8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M619.984 196.381C628.504 193.663 645.162 185.253 652.427 181.388C647.286 181.129 626.845 183.009 616.011 186.466C607.344 189.231 599.462 196.106 596.605 199.198C600.848 199.392 611.464 199.099 619.984 196.381Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M597.246 198.807C615.803 192.887 628.283 188.905 646.84 182.984" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M561.434 190.918L605.627 190.033L639.972 186.954L645.808 179.755L569.507 188.342L561.434 190.918Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M601.736 191.021C603.777 190.37 605.029 188.954 605.029 188.954C605.029 188.954 603.195 188.522 601.148 189.175C596.951 190.514 593.957 192.486 593.957 192.486C593.957 192.486 597.525 192.364 601.737 191.021"
          fill="#4E76BB"
        />
        <path
          d="M601.736 191.021C603.777 190.37 605.029 188.954 605.029 188.954C605.029 188.954 603.195 188.522 601.148 189.175C596.951 190.514 593.957 192.486 593.957 192.486C593.957 192.486 597.525 192.364 601.737 191.021"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M622.732 189.913C624.773 189.262 626.025 187.846 626.025 187.846C626.025 187.846 624.191 187.415 622.144 188.068C617.947 189.407 614.953 191.379 614.953 191.379C614.953 191.379 618.521 191.257 622.733 189.913"
          fill="#4E76BB"
        />
        <path
          d="M622.732 189.913C624.773 189.262 626.025 187.846 626.025 187.846C626.025 187.846 624.191 187.415 622.144 188.068C617.947 189.407 614.953 191.379 614.953 191.379C614.953 191.379 618.521 191.257 622.733 189.913"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M612.619 190.089C614.659 189.438 615.912 188.022 615.912 188.022C615.912 188.022 614.078 187.591 612.031 188.244C607.833 189.583 604.84 191.555 604.84 191.555C604.84 191.555 608.408 191.433 612.62 190.089"
          fill="#4E76BB"
        />
        <path
          d="M612.619 190.089C614.659 189.438 615.912 188.022 615.912 188.022C615.912 188.022 614.078 187.591 612.031 188.244C607.833 189.583 604.84 191.555 604.84 191.555C604.84 191.555 608.408 191.433 612.62 190.089"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M647.434 179.284L653.57 177.788L657.176 189.09L651.732 191.255C648.906 192.379 645.957 193.167 642.947 193.603L638.154 194.296C637.647 194.37 637.161 194.065 637.005 193.577L634.46 185.602C634.302 185.105 634.533 184.566 635.003 184.339L639.721 182.056C642.187 180.862 644.772 179.933 647.434 179.284Z"
          fill="#4569AC"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="633.387"
          y="187.022"
          width="1.45275"
          height="6.29521"
          transform="rotate(-17.6956 633.387 187.022)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M635.004 192.097C632.567 192.512 630.19 191.346 630.19 191.346C630.19 191.346 631.452 189.018 633.678 187.945L635.003 192.097L635.004 192.097Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M510.711 211.168L533.885 207.332L514.877 214.667L501.715 214.038L510.711 211.168Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="698.906"
          y="153.41"
          width="4.84247"
          height="7.74795"
          rx="1.04911"
          transform="rotate(-17.6956 698.906 153.41)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="661.539"
          y="165.333"
          width="4.84248"
          height="7.74796"
          rx="1.04911"
          transform="rotate(-17.6956 661.539 165.333)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="547.59"
          y="201.689"
          width="4.84247"
          height="7.74795"
          rx="1.04911"
          transform="rotate(-17.6956 547.59 201.689)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M389.571 319.687H403.121V326.462H389.571V319.687Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M396.348 298.233V319.687" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 298.233V380.664H441.516V298.233" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 298.233L441.516 308.395" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 318.558L441.516 328.721" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 318.558L441.516 308.395" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 338.883L441.516 328.721" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 338.884L441.516 349.046" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 359.209L441.516 369.372" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 359.209L441.516 349.046" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M431.353 379.535L441.516 369.372" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M426.833 288.07L389.57 291.457V298.233H452.805V290.328L446.03 288.07" fill="#4E76BB" />
        <path
          d="M426.833 288.07L389.57 291.457V298.233H452.805V290.328L446.03 288.07"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M446.027 298.233V277.907H430.219L426.831 288.07V298.233" fill="#FEDB55" />
        <path d="M446.027 298.233V277.907H430.219L426.831 288.07V298.233H446.027Z" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M439.254 277.907V283.553C439.254 284.751 438.778 285.9 437.931 286.747C437.084 287.594 435.935 288.07 434.737 288.07H426.833"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          width="21.4547"
          height="22.5839"
          transform="matrix(-1 0 0 1 447.16 380.664)"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          width="21.4547"
          height="22.5839"
          transform="matrix(-1 0 0 1 447.16 413.411)"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          width="14.6796"
          height="10.1628"
          transform="matrix(-1 0 0 1 443.773 403.248)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="276.156" y="329.458" width="16.4961" height="96.9145" fill="#C4D1E8" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M265.16 309.525H303.651L302.276 334.956H266.535L265.16 309.525Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M261.723 285.468H307.087L303.552 309.525H265.258L261.723 285.468Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M305.37 297.153H263.44L261.723 285.468H307.087L305.37 297.153Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M284.406 285.468V296.809" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M276.844 285.468V296.809" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M291.965 285.468V296.809" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M299.527 285.468V296.809" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M269.285 285.468V296.809" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M286 435.14V400.978L513.455 361.834L761 356.14V435.14H286Z" fill="#C4E8E6" />
        <g opacity="0.6">
          <path
            d="M460 391.828C460 391.448 460.308 391.141 460.687 391.141H554.313C554.692 391.141 555 391.448 555 391.828V435.453C555 435.833 554.692 436.141 554.313 436.141H460.687C460.308 436.141 460 435.833 460 435.453V391.828Z"
            fill="#C4E8E6"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M507.5 406.223V422.542" stroke="#060e4d" strokeWidth="1.37467" />
          <path d="M483.5 405.976V436.141" stroke="#060e4d" strokeWidth="1.37467" />
          <path d="M531.5 405.976V436.141" stroke="#060e4d" strokeWidth="1.37467" />
          <rect
            x="507.5"
            y="421.305"
            width="13"
            height="14.8352"
            fill="#4E76BB"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="494.5"
            y="421.305"
            width="13"
            height="14.8352"
            fill="#4E76BB"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="460"
            y="391.141"
            width="95"
            height="15.8242"
            rx="0.687337"
            fill="#060e4d"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M494.43 403.009V397.183H492.5V395.937H497.99V397.183H496.06V403.009H494.43Z" fill="white" />
          <path
            d="M497.234 403.009L499.584 395.937H501.694L504.014 403.009H502.324L501.834 401.436H499.244L498.754 403.009H497.234ZM500.544 397.243L499.594 400.299H501.484L500.544 397.243Z"
            fill="white"
          />
          <path
            d="M503.972 403.009L506.242 399.379L504.142 395.937H505.972L507.332 398.291L508.682 395.937H510.342L508.302 399.33L510.562 403.009H508.722L507.172 400.378L505.632 403.009H503.972Z"
            fill="white"
          />
          <path d="M512.846 403.009V395.937H517.436V397.193H514.466V399.063H516.816V400.269H514.466V403.009H512.846Z" fill="white" />
          <path
            d="M518.02 403.009V395.937H520.58C522.27 395.937 523.34 396.62 523.34 398.083V398.123C523.34 399.191 522.71 399.755 521.87 400.002L523.76 403.009H522.04L520.33 400.279H519.63V403.009H518.02ZM519.63 399.191H520.54C521.35 399.191 521.76 398.855 521.76 398.172V398.133C521.76 397.411 521.32 397.164 520.54 397.164H519.63V399.191Z"
            fill="white"
          />
          <path d="M524.239 403.009V395.937H528.899V397.183H525.849V398.835H528.289V400.002H525.849V401.763H529.059V403.009H524.239Z" fill="white" />
          <path d="M529.686 403.009V395.937H534.346V397.183H531.296V398.835H533.736V400.002H531.296V401.763H534.506V403.009H529.686Z" fill="white" />
          <path
            d="M480.5 396.271H489.5V403.241C489.5 404 488.885 404.616 488.125 404.616H481.875C481.115 404.616 480.5 404 480.5 403.241V396.271Z"
            fill="#FC323A"
          />
          <path
            d="M487.125 396.619C487.125 397.276 486.592 397.809 485.935 397.809L484.065 397.809C483.408 397.809 482.875 397.276 482.875 396.619L482.875 396.302C482.875 395.128 483.826 394.177 485 394.177C486.174 394.177 487.125 395.128 487.125 396.302L487.125 396.619Z"
            stroke="#FC323A"
            strokeWidth="1.37467"
          />
        </g>
        <path d="M345 391.14L314 422.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M399 393.14L369 424.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M472 386.14L453 404.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M526 379.14L514 391.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M561 422.14L550 432.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M568 405.14L558 415.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M626 364.14L616 374.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M624 375.14L614 385.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M693 372.14L682 382.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M725 363.14L714 373.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M724 376.14L713 386.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M680 373.14L674 378.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M306 418.14L295 427.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M331 418.14L311 436.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M401 413.14L377 436.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M467 402.14L437 432.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M583 376.14L560 398.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <rect
          x="571"
          y="384.14"
          width="190"
          height="52"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="181"
          y="317.14"
          width="34"
          height="45"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="181"
          y="317.14"
          width="34"
          height="22"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="189"
          y="373.14"
          width="18"
          height="63"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          width="79"
          height="37"
          transform="matrix(-1 0 0 1 286 399.14)"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="286" y="410.14" width="285" height="26" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <rect
          x="666"
          y="410.14"
          width="64"
          height="26"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M691 415.14L681 424.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M679 420.14L673 425.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M718 417.14L708 426.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M724 424.14L718 429.14" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M821 334.349C590.51 331.582 392.813 356.487 286 398.916V408.14C461.398 365.342 688.265 365.096 779.774 370.322L821 334.349Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="170"
          y="362.14"
          width="56"
          height="11"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="194" y="272.14" width="8" height="45" fill="#FEDB55" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M349 395.14L349 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M381 389.14L381 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M413 385.14L413 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M444 381.14L444 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M476 379.14L476 435.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M508 375.14L508 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M539 373.14L539 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M571 371.14V410.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M603 369.14V384.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M634 369.14V384.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M666 369.14V384.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M698 411.14L698 436.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M698 369.14L698 384.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M730 369.14V384.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M761 370.14V410.14" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M664.083 400.983C664.083 401.363 664.391 401.671 664.77 401.671H667.11C667.49 401.671 667.797 401.363 667.797 400.983V393.267H669.88C670.26 393.267 670.568 392.96 670.568 392.58V390.782C670.568 390.403 670.26 390.095 669.88 390.095H662C661.62 390.095 661.313 390.403 661.313 390.782V392.58C661.313 392.96 661.62 393.267 662 393.267H664.083V400.983ZM675.883 394.116C675.772 393.982 675.653 393.857 675.525 393.74C674.696 392.982 673.6 392.663 672.504 392.663C671.251 392.663 670.108 393.103 669.276 393.916C668.44 394.732 667.956 395.884 667.956 397.231V397.345C667.956 398.703 668.431 399.842 669.283 400.638C670.128 401.429 671.286 401.828 672.562 401.828C673.681 401.828 674.669 401.583 675.428 401.053C675.593 400.937 675.745 400.81 675.883 400.672V400.983C675.883 401.363 676.191 401.671 676.57 401.671H678.651C679.031 401.671 679.339 401.363 679.339 400.983V397.245C679.339 396.685 679.504 396.442 679.693 396.305C679.896 396.157 680.243 396.047 680.799 396.025V400.983C680.799 401.363 681.107 401.671 681.487 401.671H683.568C683.948 401.671 684.255 401.363 684.255 400.983V396.575C684.255 396.22 684.364 396.028 684.471 395.924C684.582 395.816 684.761 395.736 685.018 395.736C685.249 395.736 685.332 395.799 685.369 395.84C685.417 395.895 685.507 396.049 685.507 396.432V400.983C685.507 401.363 685.815 401.671 686.195 401.671H688.262C688.641 401.671 688.949 401.363 688.949 400.983V396.575C688.949 396.22 689.058 396.028 689.165 395.924C689.276 395.816 689.455 395.736 689.711 395.736C689.953 395.736 690.033 395.801 690.066 395.838C690.112 395.89 690.201 396.044 690.201 396.432V400.983C690.201 401.363 690.509 401.671 690.888 401.671H692.955C693.122 401.671 693.275 401.611 693.395 401.512C693.514 401.611 693.667 401.671 693.834 401.671H695.901C696.086 401.671 696.255 401.597 696.378 401.477C696.502 401.597 696.671 401.671 696.856 401.671H698.938C699.317 401.671 699.625 401.363 699.625 400.983V396.675C699.625 396.27 699.746 396.052 699.866 395.935C699.991 395.813 700.195 395.721 700.502 395.721C700.845 395.721 700.949 395.809 700.988 395.854C701.045 395.92 701.135 396.096 701.135 396.532V400.983C701.135 401.363 701.443 401.671 701.823 401.671H703.904C704.222 401.671 704.49 401.455 704.568 401.161C705.184 401.643 705.977 401.828 706.754 401.828C707.434 401.828 708.005 401.695 708.484 401.448C708.491 401.444 708.498 401.44 708.505 401.437C708.631 401.58 708.816 401.671 709.022 401.671H711.046C711.215 401.671 711.37 401.61 711.49 401.509C711.609 401.61 711.764 401.671 711.933 401.671H714C714.38 401.671 714.687 401.363 714.687 400.983V390.14C714.687 389.761 714.38 389.453 714 389.453H711.933C711.553 389.453 711.246 389.761 711.246 390.14V394.173C711.072 393.89 710.853 393.643 710.589 393.435C709.861 392.861 708.896 392.663 707.903 392.663C706.898 392.663 705.933 392.876 705.182 393.4C704.795 393.671 704.481 394.013 704.254 394.421C704.112 394.1 703.926 393.814 703.694 393.569C703.086 392.928 702.254 392.663 701.378 392.663C700.646 392.663 700.018 392.842 699.51 393.14C699.386 392.956 699.176 392.834 698.938 392.834H696.856C696.671 392.834 696.502 392.908 696.378 393.028C696.274 392.927 696.137 392.858 695.986 392.84C696.435 392.518 696.731 392.002 696.731 391.382C696.731 390.323 695.869 389.567 694.853 389.567C693.845 389.567 692.988 390.328 692.988 391.382C692.988 392.001 693.285 392.52 693.734 392.842C693.402 392.89 693.146 393.176 693.146 393.522V394.102C693.031 393.904 692.896 393.722 692.741 393.56C692.14 392.929 691.327 392.663 690.486 392.663C689.644 392.663 688.76 392.929 688.053 393.524C687.892 393.351 687.708 393.202 687.504 393.079C687.018 392.786 686.454 392.663 685.865 392.663C685.196 392.663 684.611 392.841 684.13 393.126C684.006 392.95 683.8 392.834 683.568 392.834H681.487C681.477 392.834 681.467 392.835 681.458 392.835C681.343 392.759 681.208 392.719 681.069 392.72C680.383 392.728 679.776 392.878 679.259 393.201C679.144 392.983 678.915 392.834 678.651 392.834H676.57C676.191 392.834 675.883 393.142 675.883 393.522V394.116ZM704.591 396.73V396.592H704.786C704.719 396.636 704.654 396.682 704.591 396.73ZM708.147 395.83C707.825 395.83 707.508 395.843 707.201 395.87C707.234 395.743 707.281 395.682 707.317 395.649C707.362 395.609 707.479 395.536 707.773 395.536C708.129 395.536 708.196 395.622 708.203 395.632L708.203 395.633C708.223 395.657 708.253 395.712 708.276 395.83H708.147ZM673.535 398.404C673.525 398.432 673.517 398.461 673.511 398.491C673.475 398.663 673.406 398.761 673.314 398.826C673.211 398.9 673.007 398.984 672.619 398.984C672.202 398.984 671.944 398.857 671.78 398.685C671.712 398.613 671.648 398.521 671.594 398.404H673.535ZM673.251 395.759H671.784C671.799 395.741 671.815 395.725 671.831 395.709C671.984 395.561 672.198 395.465 672.504 395.465C672.874 395.465 673.069 395.563 673.181 395.675C673.204 395.698 673.228 395.726 673.251 395.759ZM708.19 398.432H708.304C708.29 398.598 708.218 398.715 708.103 398.806C707.959 398.919 707.713 399.012 707.372 399.012C707.088 399.012 707.003 398.945 706.996 398.938C706.993 398.935 706.989 398.932 706.984 398.92C706.978 398.904 706.968 398.867 706.968 398.801C706.968 398.704 706.988 398.67 706.993 398.661C706.999 398.653 707.018 398.624 707.092 398.587C707.267 398.499 707.608 398.432 708.19 398.432Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M720 399.956C719.813 399.956 719.634 400.032 719.504 400.167C719.374 400.302 719.305 400.485 719.313 400.672C719.389 402.492 720.023 404.06 721.282 405.164C722.533 406.262 724.316 406.828 726.547 406.828C728.676 406.828 730.457 406.313 731.721 405.31C733.003 404.293 733.687 402.824 733.687 401.082C733.687 399.882 733.312 398.851 732.625 398.059C732.293 397.676 731.896 397.358 731.452 397.106C731.765 396.881 732.047 396.62 732.29 396.321C732.878 395.597 733.198 394.691 733.198 393.621C733.198 392.122 732.57 390.804 731.412 389.875C730.267 388.956 728.651 388.453 726.71 388.453C724.676 388.453 723.01 389.049 721.821 390.116C720.631 391.184 719.976 392.672 719.873 394.341C719.861 394.531 719.928 394.716 720.058 394.854C720.188 394.993 720.37 395.071 720.559 395.071H723.891C724.238 395.071 724.531 394.811 724.573 394.466C724.651 393.817 724.886 393.357 725.207 393.061C725.525 392.768 725.989 392.576 726.64 392.576C727.279 392.576 727.669 392.757 727.895 392.972C728.12 393.187 728.259 393.508 728.259 393.945C728.259 394.521 728.1 394.855 727.874 395.058C727.632 395.274 727.191 395.452 726.407 395.452H725.195C724.816 395.452 724.508 395.759 724.508 396.139V398.634C724.508 399.013 724.816 399.321 725.195 399.321H726.5C727.308 399.321 727.783 399.504 728.054 399.746C728.31 399.976 728.492 400.356 728.492 401.013C728.492 401.612 728.317 401.998 728.042 402.245C727.755 402.502 727.251 402.704 726.407 402.704C725.541 402.704 725.018 402.459 724.693 402.131C724.359 401.793 724.147 401.279 724.086 400.583C724.055 400.228 723.758 399.956 723.401 399.956H720Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect
          x="214.59"
          y="406.052"
          width="7.74961"
          height="10.6265"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="228.152"
          y="406.052"
          width="7.74961"
          height="10.6265"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="241.715"
          y="406.052"
          width="7.74961"
          height="10.6265"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="255.273"
          y="406.052"
          width="7.74961"
          height="10.6265"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="268.836"
          y="406.052"
          width="7.74961"
          height="10.6265"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1_4073_32864)">
          <path d="M200.652 405.984V433.092" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
          <path
            d="M208.487 410.883C207.687 407.22 204.444 404.609 200.694 404.609L139.159 404.609H66.3263C65.6656 404.609 65.1299 405.144 65.1299 405.805V432.092C65.1299 432.752 65.6656 433.288 66.3263 433.288H210.425C211.085 433.288 211.621 432.752 211.621 432.092V426.095C211.621 425.523 211.56 424.952 211.437 424.393L208.487 410.883Z"
            fill="white"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="10.9673"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 197.125 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="10.9673"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 183.031 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="10.9673"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 79.625 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="15.6675"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 143.078 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path d="M157.574 409.323L157.574 433.288" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
          <rect
            width="7.44206"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 166.973 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="7.44206"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 155.617 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path
            d="M168.934 410.912C168.934 410.251 168.398 409.715 167.737 409.715H147.412C146.751 409.715 146.216 410.251 146.216 410.912V433.288H168.934V410.912Z"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="15.6675"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 124.273 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path d="M94.1211 409.323L94.1211 433.288" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
          <rect
            width="7.44206"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 103.52 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            width="7.44206"
            height="12.179"
            rx="1.19643"
            transform="matrix(-1 0 0 1 92.1641 412.859)"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path
            d="M105.48 410.912C105.48 410.251 104.945 409.716 104.284 409.716H83.959C83.2982 409.716 82.7626 410.251 82.7626 410.912V433.288H105.48V410.912Z"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path
            d="M-58.6406 405.805C-58.6406 405.144 -58.105 404.609 -57.4442 404.609H60.8027C61.4635 404.609 61.9992 405.144 61.9992 405.805V432.092C61.9992 432.752 61.4635 433.288 60.8027 433.288H-57.4442C-58.105 433.288 -58.6406 432.752 -58.6406 432.092V405.805Z"
            fill="white"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            x="47.8945"
            y="412.858"
            width="10.9673"
            height="12.179"
            rx="1.19643"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            x="-15.5586"
            y="412.858"
            width="15.6675"
            height="12.179"
            rx="1.19643"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            x="3.24609"
            y="412.858"
            width="15.6675"
            height="12.179"
            rx="1.19643"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path d="M33.3984 409.323L33.3984 433.288" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
          <rect
            x="24"
            y="412.858"
            width="7.44207"
            height="12.179"
            rx="1.19643"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect
            x="35.3555"
            y="412.858"
            width="7.44207"
            height="12.179"
            rx="1.19643"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path
            d="M22.0391 410.912C22.0391 410.251 22.5747 409.716 23.2355 409.716H43.5605C44.2213 409.716 44.7569 410.251 44.7569 410.912V433.288H22.0391V410.912Z"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <path
            d="M-58.6445 434.191C-58.6445 433.812 -58.3368 433.504 -57.9572 433.504H209.355V435.635C209.355 436.015 209.048 436.322 208.668 436.322H-57.9572C-58.3368 436.322 -58.6445 436.015 -58.6445 435.635V434.191Z"
            fill="#060e4d"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinejoin="round"
          />
          <rect x="61.7578" y="407.317" width="3.37531" height="27.7611" fill="#060e4d" />
          <rect x="185.969" y="427.63" width="11.4761" height="2.0313" fill="#9E0817" />
        </g>
        <rect
          x="784.766"
          y="349.624"
          width="153.709"
          height="86.371"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M803.98 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M823.191 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M842.406 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M861.621 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M880.836 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M900.047 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M919.262 349.624V435.995" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 359.221H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 368.817H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 378.414H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 388.011H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <rect
          x="849.133"
          y="375.535"
          width="24.9777"
          height="24.9516"
          rx="1.37467"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M852.977 390.917V379.374H856.968C859.78 379.374 861.38 380.617 861.38 383.055V383.12C861.38 385.557 859.683 386.72 857.049 386.72H855.578V390.917H852.977ZM855.578 384.896H856.904C858.18 384.896 858.859 384.282 858.859 383.136V383.071C858.859 381.844 858.148 381.36 856.904 381.36H855.578V384.896Z"
          fill="#FFDD66"
        />
        <path d="M867.289 396.648V387.688L864.945 389.222V386.994L867.612 385.105H869.907V396.648H867.289Z" fill="#FFDD66" />
        <path d="M784.766 397.608H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 407.204H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 416.801H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M784.766 426.398H938.474" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <rect
          x="823.191"
          y="407.204"
          width="76.8544"
          height="28.7903"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M843.367 425.581C843.367 424.442 844.29 423.519 845.429 423.519H847.069C848.208 423.519 849.131 424.442 849.131 425.581V435.995H843.367V425.581Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M874.109 425.581C874.109 424.442 875.033 423.519 876.171 423.519H877.811C878.95 423.519 879.873 424.442 879.873 425.581V435.995H874.109V425.581Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="938.473"
          y="357.301"
          width="8.64612"
          height="78.6936"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="947.117"
          y="349.624"
          width="93.7571"
          height="86.371"
          fill="#C4E8E6"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M955.027 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M951.637 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M949.379 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M959.543 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M965.191 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M976.488 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M987.785 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M999.078 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1010.38 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1021.67 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1032.97 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1028.45 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1036.36 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M1038.62 350.352V435.307" stroke="white" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 423.623H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 411.25H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 398.878H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 386.506H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 361.762H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M947.449 374.134H1040.72" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M808.143 334.268H834.786L829.662 349.623H803.02L808.143 334.268Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M831.201 349.623H829.664L834.787 334.268H836.324L831.201 349.623Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M814.803 334.268L809.68 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M821.467 334.268L816.344 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M828.128 334.268L823.004 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M806.605 339.131H832.992" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M804.812 344.505H831.199" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M837.924 334.268H864.567L859.444 349.623H832.801L837.924 334.268Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M860.982 349.623H859.445L864.568 334.268H866.105L860.982 349.623Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M844.585 334.268L839.461 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M851.249 334.268L846.125 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M857.909 334.268L852.785 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M836.387 339.131H862.773" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M834.594 344.505H860.98" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M867.706 334.268H894.349L889.225 349.623H862.582L867.706 334.268Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M890.763 349.623H889.226L894.35 334.268H895.887L890.763 349.623Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M874.366 334.268L869.242 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M881.03 334.268L875.906 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M887.69 334.268L882.566 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M866.168 339.131H892.555" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M864.375 344.505H890.762" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M897.487 334.268H924.13L919.006 349.623H892.363L897.487 334.268Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M920.544 349.623H919.007L924.131 334.268H925.668L920.544 349.623Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M904.147 334.268L899.023 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M910.811 334.268L905.688 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M917.471 334.268L912.348 349.623" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M895.949 339.131H922.336" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M894.156 344.505H920.543" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M291 442.545V439.977C291 437.84 292.13 435.826 294.158 435.155C298.175 433.826 303.222 433.298 305.852 433.153C305.979 433.146 306.096 433.109 306.205 433.043C309.631 430.966 318.506 427 327.981 427C337.289 427 343.754 430.828 346.061 432.932C346.206 433.065 346.394 433.143 346.591 433.143H350.922C351.476 433.143 351.925 433.592 351.925 434.145V441.158C351.925 441.689 351.591 442.162 351.091 442.34L346.406 444.005C346.325 444.034 346.24 444.049 346.154 444.049H292.504C291.674 444.049 291 443.375 291 442.545Z"
          fill="#5F646C"
        />
        <path
          d="M351.071 436.358L306.122 441.019C305.743 441.059 305.468 441.4 305.51 441.779L305.709 443.572C305.748 443.92 306.042 444.184 306.392 444.184H346.186C346.281 444.184 346.375 444.164 346.462 444.126L351.417 441.958C351.667 441.849 351.829 441.602 351.829 441.328V437.042C351.829 436.634 351.476 436.316 351.071 436.358Z"
          fill="#629C76"
        />
        <path
          d="M291 442.545V439.977C291 437.84 292.13 435.826 294.158 435.155C298.175 433.826 303.222 433.298 305.852 433.153C305.979 433.146 306.096 433.109 306.205 433.043C309.631 430.966 318.506 427 327.981 427C337.289 427 343.754 430.828 346.061 432.932C346.206 433.065 346.394 433.143 346.591 433.143H350.922C351.476 433.143 351.925 433.592 351.925 434.145V441.158C351.925 441.689 351.591 442.162 351.091 442.34L346.406 444.005C346.325 444.034 346.24 444.049 346.154 444.049H292.504C291.674 444.049 291 443.375 291 442.545Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M312.351 441.434H311.245V438.234H310.246V437.327H313.347V438.234H312.351V441.434Z" fill="#FFDD66" />
        <path
          d="M316.197 441.434L315.995 440.664H314.666L314.459 441.434H313.244L314.579 437.31H316.054L317.406 441.434H316.197ZM315.766 439.754L315.589 439.08C315.548 438.93 315.498 438.736 315.438 438.498C315.38 438.261 315.342 438.09 315.324 437.987C315.307 438.083 315.273 438.24 315.223 438.459C315.174 438.678 315.065 439.11 314.895 439.754H315.766Z"
          fill="#FFDD66"
        />
        <path
          d="M321.291 441.434H320.012L319.214 440.15L318.425 441.434H317.174L318.531 439.333L317.255 437.327H318.481L319.22 438.597L319.931 437.327H321.193L319.897 439.42L321.291 441.434Z"
          fill="#FFDD66"
        />
        <path d="M321.507 441.434V437.327H322.618V441.434H321.507Z" fill="#FFDD66" />
        <path
          d="M306.148 433.076L309.163 434.217C309.257 434.252 309.357 434.269 309.458 434.265L338.754 433.148C338.844 433.144 338.933 433.125 339.016 433.09L343.631 431.152C340.409 429.178 335.006 427 327.984 427C318.51 427 309.634 430.966 306.208 433.043C306.188 433.055 306.169 433.066 306.148 433.076Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M351.533 433.351C351.77 433.534 351.923 433.822 351.923 434.145V435.65H346.72C346.598 435.65 346.479 435.612 346.379 435.542C345.956 435.246 346.085 434.589 346.589 434.475L351.533 433.351Z"
          fill="#4E76BB"
        />
        <path
          d="M291.312 438.076C291.779 436.728 292.752 435.619 294.157 435.155C294.359 435.088 294.565 435.023 294.772 434.96L296.66 436.065C297.275 436.425 297.092 437.358 296.386 437.459L291.715 438.126C291.568 438.147 291.431 438.127 291.312 438.076Z"
          fill="#4E76BB"
        />
        <path
          d="M351.533 433.351C351.77 433.534 351.923 433.822 351.923 434.145V435.65H346.72C346.598 435.65 346.479 435.612 346.379 435.542C345.956 435.246 346.085 434.589 346.589 434.475L351.533 433.351Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M291.312 438.076C291.779 436.728 292.752 435.619 294.157 435.155C294.359 435.088 294.565 435.023 294.772 434.96L296.66 436.065C297.275 436.425 297.092 437.358 296.386 437.459L291.715 438.126C291.568 438.147 291.431 438.127 291.312 438.076Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <circle cx="301.279" cy="443.297" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="301.278" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="339.638" cy="443.297" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="339.637" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M328.108 427L325.977 433.017L325.028 435.39C324.992 435.479 324.974 435.574 324.974 435.669V444.049M309.304 433.895L308.31 435.331C308.222 435.457 308.176 435.606 308.176 435.759V442.609C308.176 442.809 308.255 443 308.396 443.141L309.304 444.049M338.011 433.017L338.471 434.489C338.57 434.806 338.45 435.15 338.175 435.336L334.596 437.757C334.454 437.854 334.348 437.996 334.298 438.16L332.495 444.049"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M322.799 424.887L322.679 426.507C322.647 426.939 323.019 427.293 323.45 427.239L324.712 427.082C325.078 427.036 325.342 426.71 325.312 426.343L325.19 424.881C325.16 424.525 324.862 424.25 324.505 424.25H323.485C323.125 424.25 322.826 424.528 322.799 424.887Z"
          fill="#FFDD66"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
        />
        <path
          d="M310.246 434.07C310.246 433.582 310.642 433.186 311.13 433.186L312.308 433.186V436.132H311.13C310.642 436.132 310.246 435.736 310.246 435.248V434.07Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M362.484 442.544V439.977C362.484 437.84 363.614 435.825 365.643 435.154C369.659 433.826 374.706 433.298 377.337 433.152C377.464 433.145 377.58 433.109 377.689 433.043C381.115 430.966 389.991 427 399.465 427C408.774 427 415.238 430.828 417.545 432.932C417.691 433.065 417.878 433.142 418.075 433.142H422.406C422.96 433.142 423.409 433.591 423.409 434.145V441.158C423.409 441.689 423.075 442.162 422.575 442.339L417.89 444.005C417.809 444.034 417.724 444.049 417.638 444.049H363.989C363.158 444.049 362.484 443.375 362.484 442.544Z"
          fill="#5F646C"
        />
        <path
          d="M422.555 436.358L377.607 441.019C377.227 441.059 376.952 441.4 376.994 441.779L377.194 443.572C377.232 443.92 377.527 444.184 377.877 444.184H417.671C417.766 444.184 417.859 444.164 417.946 444.126L422.901 441.958C423.152 441.849 423.313 441.602 423.313 441.328V437.042C423.313 436.634 422.96 436.316 422.555 436.358Z"
          fill="#629C76"
        />
        <path
          d="M362.484 442.544V439.977C362.484 437.84 363.614 435.825 365.643 435.154C369.659 433.826 374.706 433.298 377.337 433.152C377.464 433.145 377.58 433.109 377.689 433.043C381.115 430.966 389.991 427 399.465 427C408.774 427 415.238 430.828 417.545 432.932C417.691 433.065 417.878 433.142 418.075 433.142H422.406C422.96 433.142 423.409 433.591 423.409 434.145V441.158C423.409 441.689 423.075 442.162 422.575 442.339L417.89 444.005C417.809 444.034 417.724 444.049 417.638 444.049H363.989C363.158 444.049 362.484 443.375 362.484 442.544Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M383.835 441.434H382.73V438.234H381.73V437.327H384.831V438.234H383.835V441.434Z" fill="#FFDD66" />
        <path
          d="M387.681 441.434L387.48 440.664H386.15L385.943 441.434H384.728L386.063 437.31H387.538L388.89 441.434H387.681ZM387.25 439.754L387.074 439.08C387.033 438.93 386.982 438.736 386.923 438.498C386.865 438.261 386.827 438.09 386.808 437.987C386.791 438.083 386.758 438.24 386.707 438.459C386.659 438.678 386.549 439.11 386.38 439.754H387.25Z"
          fill="#FFDD66"
        />
        <path
          d="M392.775 441.434H391.496L390.699 440.15L389.909 441.434H388.658L390.016 439.333L388.74 437.327H389.965L390.704 438.597L391.415 437.327H392.677L391.382 439.42L392.775 441.434Z"
          fill="#FFDD66"
        />
        <path d="M392.991 441.434V437.327H394.103V441.434H392.991Z" fill="#FFDD66" />
        <path
          d="M377.629 433.076L380.644 434.217C380.738 434.252 380.838 434.269 380.938 434.265L410.234 433.148C410.325 433.144 410.414 433.125 410.497 433.09L415.111 431.152C411.89 429.178 406.486 427 399.465 427C389.99 427 381.114 430.966 377.688 433.043C377.669 433.055 377.649 433.066 377.629 433.076Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M423.017 433.351C423.255 433.534 423.408 433.822 423.408 434.145V435.65H418.205C418.083 435.65 417.964 435.612 417.864 435.542C417.441 435.246 417.57 434.589 418.073 434.475L423.017 433.351Z"
          fill="#4E76BB"
        />
        <path
          d="M362.797 438.076C363.263 436.728 364.237 435.619 365.641 435.155C365.844 435.088 366.049 435.023 366.256 434.96L368.144 436.065C368.759 436.425 368.576 437.358 367.871 437.459L363.2 438.126C363.052 438.147 362.916 438.127 362.797 438.076Z"
          fill="#4E76BB"
        />
        <path
          d="M423.017 433.351C423.255 433.534 423.408 433.822 423.408 434.145V435.65H418.205C418.083 435.65 417.964 435.612 417.864 435.542C417.441 435.246 417.57 434.589 418.073 434.475L423.017 433.351Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M362.797 438.076C363.263 436.728 364.237 435.619 365.641 435.155C365.844 435.088 366.049 435.023 366.256 434.96L368.144 436.065C368.759 436.425 368.576 437.358 367.871 437.459L363.2 438.126C363.052 438.147 362.916 438.127 362.797 438.076Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <circle cx="372.767" cy="443.297" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="372.766" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="411.126" cy="443.297" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="411.125" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M399.588 427L397.457 433.017L396.508 435.39C396.473 435.479 396.454 435.574 396.454 435.669V444.049M380.784 433.895L379.79 435.331C379.703 435.457 379.656 435.606 379.656 435.759V442.609C379.656 442.809 379.735 443 379.877 443.141L380.784 444.049M409.492 433.017L409.952 434.489C410.051 434.806 409.93 435.15 409.655 435.336L406.076 437.757C405.934 437.854 405.829 437.996 405.779 438.16L403.976 444.049"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M394.284 424.887L394.164 426.507C394.131 426.939 394.504 427.293 394.934 427.239L396.196 427.082C396.562 427.036 396.827 426.71 396.796 426.343L396.674 424.881C396.645 424.525 396.347 424.25 395.989 424.25H394.969C394.609 424.25 394.31 424.528 394.284 424.887Z"
          fill="#FFDD66"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
        />
        <path
          d="M381.73 434.07C381.73 433.582 382.126 433.186 382.614 433.186L383.792 433.186V436.132H382.614C382.126 436.132 381.73 435.736 381.73 435.248V434.07Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M433.969 442.545V439.977C433.969 437.84 435.098 435.826 437.127 435.155C441.144 433.826 446.19 433.298 448.821 433.153C448.948 433.146 449.065 433.109 449.174 433.043C452.599 430.966 461.475 427 470.95 427C480.258 427 486.723 430.828 489.029 432.932C489.175 433.065 489.362 433.143 489.559 433.143H493.89C494.444 433.143 494.893 433.592 494.893 434.145V441.158C494.893 441.689 494.56 442.162 494.06 442.34L489.374 444.005C489.294 444.034 489.208 444.049 489.122 444.049H435.473C434.642 444.049 433.969 443.375 433.969 442.545Z"
          fill="#5F646C"
        />
        <path
          d="M494.039 436.358L449.091 441.019C448.712 441.059 448.437 441.4 448.479 441.779L448.678 443.572C448.717 443.92 449.011 444.184 449.361 444.184H489.155C489.25 444.184 489.344 444.164 489.431 444.126L494.386 441.958C494.636 441.849 494.798 441.602 494.798 441.328V437.042C494.798 436.634 494.445 436.316 494.039 436.358Z"
          fill="#629C76"
        />
        <path
          d="M433.969 442.545V439.977C433.969 437.84 435.098 435.826 437.127 435.155C441.144 433.826 446.19 433.298 448.821 433.153C448.948 433.146 449.065 433.109 449.174 433.043C452.599 430.966 461.475 427 470.95 427C480.258 427 486.723 430.828 489.029 432.932C489.175 433.065 489.362 433.143 489.559 433.143H493.89C494.444 433.143 494.893 433.592 494.893 434.145V441.158C494.893 441.689 494.56 442.162 494.06 442.34L489.374 444.005C489.294 444.034 489.208 444.049 489.122 444.049H435.473C434.642 444.049 433.969 443.375 433.969 442.545Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M455.316 441.434H454.21V438.234H453.211V437.327H456.312V438.234H455.316V441.434Z" fill="#FFDD66" />
        <path
          d="M459.162 441.434L458.96 440.664H457.631L457.424 441.434H456.209L457.544 437.31H459.019L460.371 441.434H459.162ZM458.731 439.754L458.554 439.08C458.513 438.93 458.463 438.736 458.403 438.498C458.345 438.261 458.307 438.09 458.288 437.987C458.272 438.083 458.238 438.24 458.188 438.459C458.139 438.678 458.03 439.11 457.86 439.754H458.731Z"
          fill="#FFDD66"
        />
        <path
          d="M464.256 441.434H462.977L462.179 440.15L461.39 441.434H460.139L461.496 439.333L460.22 437.327H461.446L462.185 438.597L462.896 437.327H464.158L462.862 439.42L464.256 441.434Z"
          fill="#FFDD66"
        />
        <path d="M464.472 441.434V437.327H465.583V441.434H464.472Z" fill="#FFDD66" />
        <path
          d="M449.113 433.076L452.128 434.217C452.222 434.252 452.322 434.269 452.423 434.265L481.719 433.148C481.809 433.144 481.898 433.125 481.981 433.09L486.595 431.152C483.374 429.178 477.971 427 470.949 427C461.474 427 452.599 430.966 449.173 433.043C449.153 433.055 449.133 433.066 449.113 433.076Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M494.497 433.351C494.735 433.534 494.888 433.822 494.888 434.145V435.65H489.685C489.563 435.65 489.444 435.612 489.344 435.542C488.921 435.246 489.05 434.589 489.553 434.475L494.497 433.351Z"
          fill="#4E76BB"
        />
        <path
          d="M434.277 438.076C434.743 436.728 435.717 435.619 437.122 435.155C437.324 435.088 437.529 435.023 437.737 434.96L439.625 436.065C440.24 436.425 440.056 437.358 439.351 437.459L434.68 438.126C434.532 438.147 434.396 438.127 434.277 438.076Z"
          fill="#4E76BB"
        />
        <path
          d="M494.497 433.351C494.735 433.534 494.888 433.822 494.888 434.145V435.65H489.685C489.563 435.65 489.444 435.612 489.344 435.542C488.921 435.246 489.05 434.589 489.553 434.475L494.497 433.351Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M434.277 438.076C434.743 436.728 435.717 435.619 437.122 435.155C437.324 435.088 437.529 435.023 437.737 434.96L439.625 436.065C440.24 436.425 440.056 437.358 439.351 437.459L434.68 438.126C434.532 438.147 434.396 438.127 434.277 438.076Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <circle cx="444.247" cy="443.297" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="444.246" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="482.607" cy="443.296" r="4.51293" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="482.606" cy="443.297" r="0.820533" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M471.073 427L468.942 433.017L467.993 435.39C467.957 435.479 467.939 435.574 467.939 435.669V444.049M452.269 433.895L451.274 435.331C451.187 435.457 451.141 435.606 451.141 435.759V442.609C451.141 442.809 451.22 443 451.361 443.141L452.269 444.049M480.976 433.017L481.436 434.489C481.535 434.806 481.415 435.15 481.14 435.336L477.561 437.757C477.418 437.854 477.313 437.996 477.263 438.16L475.46 444.049"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M465.768 424.887L465.648 426.507C465.616 426.939 465.988 427.293 466.419 427.239L467.681 427.082C468.047 427.036 468.311 426.71 468.281 426.343L468.159 424.881C468.129 424.525 467.831 424.25 467.474 424.25H466.453C466.093 424.25 465.794 424.528 465.768 424.887Z"
          fill="#FFDD66"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
        />
        <path
          d="M453.211 434.07C453.211 433.582 453.607 433.186 454.095 433.186L455.273 433.186V436.132H454.095C453.607 436.132 453.211 435.736 453.211 435.248V434.07Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M579.112 464.604H567.375L584.329 517.132H596.5L601.282 512.356V499.333L579.112 464.604Z"
          fill="#FFDD66"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M506.953 464.062C506.953 462.923 507.876 462 509.015 462H567.688C568.547 462 569.316 462.533 569.618 463.337L585.023 504.36C585.529 505.708 584.533 507.147 583.093 507.147H506.953V464.062Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M541.296 470.682L533.978 497.597H514.344L521.671 470.694L541.296 470.682Z" fill="#060e4d" />
        <path d="M531.368 486.498V489.636H530.52V486.498H528.824V494.189H530.52V490.932H531.368V494.189H533.064V486.498H531.368Z" fill="white" />
        <path
          d="M521.209 489.37V488.095C521.209 487.929 521.072 487.794 520.904 487.794H520.723C520.554 487.794 520.417 487.929 520.417 488.095V492.572C520.417 492.738 520.554 492.874 520.723 492.874H520.904C521.072 492.874 521.209 492.738 521.209 492.572V491.238H522.91V492.999C522.91 493.654 522.37 494.186 521.706 494.186H519.923C519.258 494.186 518.719 493.654 518.719 492.999V487.68C518.719 487.025 519.258 486.493 519.923 486.493H521.706C522.37 486.493 522.91 487.025 522.91 487.68V489.37H521.209Z"
          fill="white"
        />
        <path
          d="M526.811 486.493H523.824V494.186H525.52V492.138H526.811C527.476 492.138 528.013 491.606 528.013 490.948V487.68C528.013 487.025 527.476 486.493 526.811 486.493ZM526.32 490.543C526.32 490.711 526.182 490.844 526.014 490.844H525.52V487.794H526.014C526.182 487.794 526.32 487.929 526.32 488.095V490.543Z"
          fill="white"
        />
        <path
          d="M472.062 520.605H503.907V476.072C503.907 475.272 503.227 474.641 502.429 474.701L479.99 476.399C477.121 476.616 474.691 478.596 473.9 481.362L470.398 493.602C470.134 494.525 470 495.479 470 496.438V518.543C470 519.682 470.923 520.605 472.062 520.605Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M470 500.201H480.243L483.476 492.206H498.256V481.101H474.355C474.017 481.694 473.746 482.333 473.553 483.009L470.502 493.672C470.169 494.836 470 496.04 470 497.25V500.201Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect x="504.344" y="507.147" width="75.639" height="13.0232" fill="#060e4d" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M470.438 512.356H498.259V520.17H471.812C471.053 520.17 470.438 519.555 470.438 518.796V512.356Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <rect x="504.344" y="477.628" width="2.60824" height="42.5426" fill="#060e4d" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M572.156 507.147H583.893L589.545 517.566H572.156V507.147Z"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <ellipse cx="493.911" cy="518.434" rx="9.56355" ry="9.55037" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <ellipse cx="493.911" cy="518.434" rx="1.73883" ry="1.73643" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <ellipse cx="566.939" cy="518.434" rx="9.56355" ry="9.55037" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <ellipse cx="566.942" cy="518.434" rx="1.73883" ry="1.73643" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <g clipPath="url(#clip2_4073_32864)">
          <path
            d="M550.084 486.825L552.253 488.218L551.126 481.983L544.977 483.543L547.16 484.945L542.438 492.32C542.096 492.854 542.073 493.533 542.378 494.09C542.683 494.646 543.267 494.992 543.903 494.992H552.597V491.519H547.079L550.084 486.825Z"
            fill="#060e4d"
          />
          <path
            d="M569.714 492.323L565.288 485.377L562.353 487.242L565.079 491.519H558.683V488.914L554.336 493.255L558.683 497.596V494.992H568.247C568.881 494.992 569.465 494.647 569.771 494.091C570.076 493.535 570.054 492.858 569.714 492.323Z"
            fill="#060e4d"
          />
          <path
            d="M558.786 481.647L556.583 482.976L562.686 484.709L563.989 478.509L561.764 479.852L557.546 473.224C557.227 472.722 556.673 472.418 556.079 472.418C555.484 472.418 554.93 472.722 554.611 473.222L550.738 479.3L553.673 481.165L556.077 477.39L558.786 481.647Z"
            fill="#060e4d"
          />
        </g>
        <path
          d="M987.801 495.252V488.592C987.801 486.455 988.922 484.442 990.911 483.659C997.373 481.115 1006.42 480.162 1010.84 479.925C1010.97 479.918 1011.08 479.883 1011.19 479.816C1016.42 476.623 1030.19 470.429 1044.91 470.429C1059.45 470.429 1069.5 476.483 1072.95 479.706C1073.1 479.84 1073.28 479.915 1073.48 479.915H1080.88C1081.43 479.915 1081.88 480.364 1081.88 480.918V492.775C1081.88 493.305 1081.55 493.778 1081.05 493.956L1073.29 496.713C1073.21 496.742 1073.13 496.757 1073.04 496.757H989.305C988.474 496.757 987.801 496.083 987.801 495.252Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M1039.35 477.99L1034.31 496.548H1020.79L1025.83 477.998L1039.35 477.99Z" fill="#060e4d" />
        <path d="M1032.51 488.895V491.058H1031.93V488.895H1030.76V494.198H1031.93V491.952H1032.51V494.198H1033.68V488.895H1032.51Z" fill="white" />
        <path
          d="M1025.52 490.875V489.996C1025.52 489.882 1025.42 489.788 1025.31 489.788H1025.18C1025.06 489.788 1024.97 489.882 1024.97 489.996V493.083C1024.97 493.197 1025.06 493.291 1025.18 493.291H1025.31C1025.42 493.291 1025.52 493.197 1025.52 493.083V492.163H1026.69V493.377C1026.69 493.829 1026.32 494.196 1025.86 494.196H1024.63C1024.17 494.196 1023.8 493.829 1023.8 493.377V489.71C1023.8 489.258 1024.17 488.891 1024.63 488.891H1025.86C1026.32 488.891 1026.69 489.258 1026.69 489.71V490.875H1025.52Z"
          fill="white"
        />
        <path
          d="M1029.37 488.891H1027.32V494.196H1028.48V492.783H1029.37C1029.83 492.783 1030.2 492.417 1030.2 491.963V489.71C1030.2 489.258 1029.83 488.891 1029.37 488.891ZM1029.03 491.684C1029.03 491.8 1028.94 491.891 1028.82 491.891H1028.48V489.788H1028.82C1028.94 489.788 1029.03 489.882 1029.03 489.996V491.684Z"
          fill="white"
        />
        <path
          d="M1011.19 479.812L1015.84 481.574C1015.99 481.629 1016.14 481.654 1016.3 481.648L1061.54 479.923C1061.68 479.918 1061.81 479.887 1061.94 479.833L1069.07 476.84C1064.09 473.793 1055.75 470.429 1044.91 470.429C1030.28 470.429 1016.57 476.554 1011.28 479.762C1011.25 479.78 1011.22 479.797 1011.19 479.812Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M1081.28 480.237C1081.65 480.521 1081.88 480.965 1081.88 481.464V483.787H1073.85C1073.66 483.787 1073.48 483.729 1073.32 483.621C1072.67 483.164 1072.87 482.149 1073.64 481.972L1081.28 480.237Z"
          fill="#4E76BB"
        />
        <path
          d="M988.285 487.534C989.005 485.453 990.508 483.74 992.678 483.022C992.99 482.919 993.307 482.819 993.627 482.722L996.543 484.429C997.492 484.984 997.209 486.425 996.121 486.581L988.907 487.611C988.679 487.644 988.468 487.612 988.285 487.534Z"
          fill="#4E76BB"
        />
        <path
          d="M1081.28 480.237C1081.65 480.521 1081.88 480.965 1081.88 481.464V483.787H1073.85C1073.66 483.787 1073.48 483.729 1073.32 483.621C1072.67 483.164 1072.87 482.149 1073.64 481.972L1081.28 480.237Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M988.285 487.534C989.005 485.453 990.508 483.74 992.678 483.022C992.99 482.919 993.307 482.819 993.627 482.722L996.543 484.429C997.492 484.984 997.209 486.425 996.121 486.581L988.907 487.611C988.679 487.644 988.468 487.612 988.285 487.534Z"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <circle cx="1003.68" cy="495.595" r="6.96903" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="1003.68" cy="495.595" r="1.2671" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="1062.91" cy="495.595" r="6.96903" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="1062.91" cy="495.595" r="1.2671" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M1045.1 470.429L1041.81 479.721L1040.31 483.458C1040.28 483.547 1040.26 483.642 1040.26 483.738V496.757M1016.06 481.076L1014.45 483.4C1014.37 483.526 1014.32 483.675 1014.32 483.828V494.703C1014.32 494.902 1014.4 495.094 1014.54 495.235L1016.06 496.757M1060.39 479.721L1061.19 482.285C1061.29 482.602 1061.17 482.946 1060.9 483.132L1055 487.122C1054.86 487.218 1054.75 487.361 1054.7 487.525L1051.88 496.757"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M1017.52 480.866C1017.52 480.378 1017.92 479.982 1018.4 479.982L1020.7 479.982V484.531H1018.4C1017.92 484.531 1017.52 484.135 1017.52 483.647V480.866Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M70.5931 493.573C77.0577 491.497 79.4348 499.976 78.244 502.744L32.6514 502.571C32.5153 501.187 34.866 500.149 36.0584 499.803C34.584 499.86 31.6693 499.214 31.8054 496.169C31.9415 493.123 36.6255 493.631 38.9505 494.265C38.27 493.573 37.3173 491.393 38.9505 488.209C40.5837 485.025 45.5285 486.652 47.7968 487.863C46.209 484.575 45.313 478 54.4316 478C63.5501 478 64.4687 485.152 63.7882 488.728C64.6389 486.767 67.2587 483.606 70.9334 486.652C74.608 489.697 72.2376 492.535 70.5931 493.573Z"
          fill="#A3C797"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M947.227 452.558C947.227 452.178 947.534 451.871 947.914 451.871H964.41C964.79 451.871 965.097 452.178 965.097 452.558V493.111C965.097 493.49 964.79 493.798 964.41 493.798H947.914C947.534 493.798 947.227 493.49 947.227 493.111V452.558Z"
          fill="#33508E"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <g clipPath="url(#clip3_4073_32864)">
          <path
            d="M954.445 479.708L954.445 480.395L957.882 480.395L957.882 479.708C957.882 479.518 957.728 479.364 957.538 479.364L954.789 479.364C954.599 479.364 954.445 479.518 954.445 479.708Z"
            fill="white"
          />
          <path
            d="M958.225 489.674L954.101 489.674C953.722 489.674 953.414 489.366 953.414 488.987L953.414 486.877L952.727 486.349L952.727 488.987C952.727 489.745 953.343 490.361 954.101 490.361L958.225 490.361C958.983 490.361 959.6 489.745 959.6 488.987L959.6 487.462L958.913 487.275L958.913 488.987C958.913 489.366 958.604 489.674 958.225 489.674Z"
            fill="white"
          />
          <path
            d="M952.727 482.457L952.727 487.338L953.414 487.588L953.414 482.457C953.414 482.078 953.722 481.77 954.101 481.77L958.225 481.77C958.604 481.77 958.913 482.078 958.913 482.457L958.913 488.041L959.6 488.517L959.6 482.457C959.6 481.699 958.983 481.083 958.225 481.083L954.101 481.083C953.343 481.083 952.727 481.699 952.727 482.457Z"
            fill="white"
          />
          <path
            d="M957.966 485.4C957.924 485.315 957.841 485.262 957.75 485.262H956.388L957.246 482.765C957.287 482.645 957.24 482.512 957.134 482.45C957.027 482.389 956.896 482.418 956.823 482.52L954.379 485.88C954.322 485.958 954.312 486.063 954.353 486.151C954.395 486.24 954.48 486.296 954.572 486.296H955.963L955.314 488.813C955.283 488.934 955.339 489.062 955.447 489.115C955.48 489.131 955.515 489.139 955.55 489.139C955.628 489.139 955.704 489.1 955.751 489.028L957.95 485.668C958.002 485.588 958.008 485.486 957.966 485.4L957.966 485.4Z"
            fill="white"
          />
        </g>
        <path
          d="M950.66 461.493C950.66 461.114 950.968 460.806 951.347 460.806H960.97C961.35 460.806 961.658 461.114 961.658 461.493V471.804C961.658 472.183 961.35 472.491 960.97 472.491H951.347C950.968 472.491 950.66 472.183 950.66 471.804V461.493Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M852.683 494.809C851.979 494.809 851.389 494.278 851.316 493.578L851.043 490.984C850.858 489.233 851.277 487.472 852.228 485.992C853.272 484.368 854.885 483.193 856.751 482.699L870.691 479C871.129 478.708 871.558 478.422 871.977 478.142C880.835 472.228 885.72 468.966 896.33 465.87C897.784 465.446 899.294 465.246 900.808 465.23L930.516 464.93C931.322 464.922 932.106 465.148 932.728 465.597H934.37C934.832 465.597 935.163 466.045 935.027 466.487L934.458 468.334C936.31 472.558 938.339 479.966 938.013 490.119L939.48 491.167C939.661 491.296 939.768 491.504 939.768 491.726V493.389C939.768 493.63 939.641 493.854 939.434 493.978L938.213 494.711C938.106 494.775 937.984 494.809 937.859 494.809L929.458 496.184H863.13L852.683 494.809Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M856.43 494.809H852.684C851.981 494.809 851.391 494.278 851.317 493.579L851.121 491.716H854.458C854.719 491.716 854.957 491.863 855.073 492.096L856.43 494.809Z"
          fill="#33508E"
        />
        <path
          d="M856.43 494.809V495.497H857.542L857.044 494.502L856.43 494.809ZM851.317 493.579L852.001 493.507L852.001 493.507L851.317 493.579ZM851.121 491.716V491.029H850.358L850.438 491.788L851.121 491.716ZM855.073 492.096L854.458 492.404L854.458 492.404L855.073 492.096ZM852.684 495.497H856.43V494.122H852.684V495.497ZM850.634 493.651C850.744 494.7 851.629 495.497 852.684 495.497V494.122C852.332 494.122 852.038 493.856 852.001 493.507L850.634 493.651ZM850.438 491.788L850.634 493.651L852.001 493.507L851.805 491.644L850.438 491.788ZM854.458 491.029H851.121V492.404H854.458V491.029ZM855.688 491.789C855.455 491.323 854.979 491.029 854.458 491.029V492.404L854.458 492.404L855.688 491.789ZM857.044 494.502L855.688 491.789L854.458 492.404L855.815 495.117L857.044 494.502Z"
          fill="#060e4d"
        />
        <path
          d="M904.027 469.034C904.027 468.654 904.335 468.347 904.715 468.347H928.562C928.885 468.347 929.164 468.572 929.233 468.887L931.338 478.51C931.432 478.939 931.106 479.344 930.667 479.344H904.715C904.335 479.344 904.027 479.036 904.027 478.657V469.034Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          d="M872.016 478.116L874.326 479.272C874.421 479.319 874.527 479.344 874.633 479.344H898.872C899.251 479.344 899.559 479.036 899.559 478.657V469.034C899.559 468.654 899.251 468.347 898.872 468.347H889.085C882.942 470.825 878.563 473.745 872.016 478.116Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M851.098 488.902L857.249 487.918C857.406 487.893 857.549 487.815 857.654 487.696L859.829 485.25C860.06 484.99 860.048 484.594 859.802 484.348C859.647 484.192 859.424 484.125 859.208 484.168L853.066 485.397C852.702 485.769 852.374 486.179 852.088 486.623C851.634 487.329 851.301 488.1 851.098 488.902Z"
          fill="#33508E"
        />
        <path
          d="M851.098 488.902L850.431 488.733L850.174 489.746L851.206 489.581L851.098 488.902ZM857.249 487.918L857.14 487.239L857.249 487.918ZM857.654 487.696L858.168 488.153L858.168 488.153L857.654 487.696ZM859.829 485.25L859.315 484.793L859.315 484.793L859.829 485.25ZM859.802 484.348L860.288 483.862L860.288 483.862L859.802 484.348ZM859.208 484.168L859.073 483.494V483.494L859.208 484.168ZM853.066 485.397L852.931 484.723L852.723 484.764L852.574 484.916L853.066 485.397ZM852.088 486.623L851.51 486.251L851.51 486.251L852.088 486.623ZM851.206 489.581L857.358 488.597L857.14 487.239L850.989 488.224L851.206 489.581ZM857.358 488.597C857.671 488.547 857.957 488.39 858.168 488.153L857.14 487.239L857.14 487.239L857.358 488.597ZM858.168 488.153L860.342 485.706L859.315 484.793L857.14 487.239L858.168 488.153ZM860.342 485.706C860.815 485.174 860.792 484.365 860.288 483.862L859.316 484.834C859.305 484.823 859.304 484.805 859.315 484.793L860.342 485.706ZM860.288 483.862C859.97 483.544 859.514 483.406 859.073 483.494L859.343 484.842C859.333 484.844 859.323 484.841 859.316 484.834L860.288 483.862ZM859.073 483.494L852.931 484.723L853.2 486.071L859.343 484.842L859.073 483.494ZM852.574 484.916C852.178 485.321 851.821 485.768 851.51 486.251L852.666 486.995C852.926 486.59 853.225 486.216 853.557 485.877L852.574 484.916ZM851.51 486.251C851.016 487.021 850.653 487.859 850.431 488.733L851.764 489.071C851.949 488.34 852.253 487.638 852.666 486.995L851.51 486.251Z"
          fill="#060e4d"
        />
        <path d="M899.559 478.313V495.496" stroke="#060e4d" strokeWidth="1.37467" />
        <path d="M897.84 478.657L892.987 496.528H879.969L884.827 478.665L897.84 478.657Z" fill="#060e4d" />
        <path d="M891.261 489.158V491.242H890.699V489.158H889.574V494.265H890.699V492.102H891.261V494.265H892.385V489.158H891.261Z" fill="white" />
        <path
          d="M884.523 491.065V490.219C884.523 490.108 884.432 490.018 884.32 490.018H884.2C884.088 490.018 883.997 490.108 883.997 490.219V493.191C883.997 493.301 884.088 493.391 884.2 493.391H884.32C884.432 493.391 884.523 493.301 884.523 493.191V492.305H885.65V493.475C885.65 493.91 885.292 494.263 884.852 494.263H883.67C883.229 494.263 882.871 493.91 882.871 493.475V489.943C882.871 489.508 883.229 489.155 883.67 489.155H884.852C885.292 489.155 885.65 489.508 885.65 489.943V491.065H884.523Z"
          fill="white"
        />
        <path
          d="M888.234 489.155H886.254V494.263H887.378V492.903H888.234C888.675 492.903 889.031 492.55 889.031 492.113V489.943C889.031 489.508 888.675 489.155 888.234 489.155ZM887.909 491.844C887.909 491.955 887.818 492.044 887.706 492.044H887.378V490.018H887.706C887.818 490.018 887.909 490.108 887.909 490.219V491.844Z"
          fill="white"
        />
        <circle cx="867.6" cy="494.466" r="6.87337" fill="white" stroke="#060e4d" strokeWidth="1.37467" />
        <circle cx="867.597" cy="494.465" r="1.37467" fill="white" stroke="#060e4d" strokeWidth="1.37467" />
        <circle cx="924.647" cy="494.466" r="6.87337" fill="white" stroke="#060e4d" strokeWidth="1.37467" />
        <circle
          cx="1.37467"
          cy="1.37467"
          r="1.37467"
          transform="matrix(1 0 0 -1 923.273 495.84)"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
        />
        <path d="M874.816 479.344L873.82 482.331C873.797 482.401 873.785 482.474 873.785 482.548V491.372" stroke="#060e4d" strokeWidth="1.37467" />
        <path d="M911.586 482.781H926.364M917.085 468.347L917.772 479" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" />
        <ellipse
          cx="956.457"
          cy="476.11"
          rx="1.2458"
          ry="1.55725"
          transform="rotate(-180 956.457 476.11)"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M953.969 476.111C953.969 475.595 954.387 475.176 954.903 475.176L957.083 475.176L957.083 477.045L954.903 477.045C954.387 477.045 953.969 476.627 953.969 476.111Z"
          fill="#33508E"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M930.973 483.94H932.275C933.995 483.94 935.39 485.335 935.39 487.055V489.914C935.39 491.3 936.513 492.424 937.899 492.424V492.424C939.285 492.424 940.409 491.3 940.409 489.914V479.225C940.409 477.505 941.803 476.11 943.523 476.11H954.095"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <ellipse cx="931.285" cy="484.015" rx="1.2458" ry="1.55725" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M933.777 484.015C933.777 484.531 933.359 484.949 932.843 484.949L930.663 484.949L930.663 483.081L932.843 483.081C933.359 483.081 933.777 483.499 933.777 484.015Z"
          fill="#33508E"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M790.273 501.081V466.239H806.771C808.804 466.239 810.642 467.446 811.45 469.312L817.197 482.58C817.936 484.286 818.317 486.125 818.317 487.984V499.381C818.317 500.32 817.556 501.081 816.617 501.081H790.273Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M726.539 463.69C726.539 462.282 727.68 461.141 729.088 461.141H787.725C789.133 461.141 790.274 462.282 790.274 463.69V501.081H726.539V463.69Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="726.539"
          y="494.283"
          width="63.7349"
          height="6.79839"
          fill="#060e4d"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M814.066 490.884C814.066 489.945 814.827 489.184 815.766 489.184H818.315V495.982H815.766C814.827 495.982 814.066 495.222 814.066 494.283V490.884Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M798.77 486.21V466.239H806.23C808.655 466.239 810.837 467.711 811.745 469.958L818.315 486.21H798.77Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M814.066 484.085C814.066 485.024 813.305 485.785 812.367 485.785L811.517 485.785L811.517 480.686L812.367 480.686C813.305 480.686 814.066 481.447 814.066 482.385L814.066 484.085Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="743.535" cy="500.231" r="7.64819" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="743.532" cy="500.231" r="1.6996" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="803.871" cy="500.231" r="7.64819" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="803.868" cy="500.231" r="1.6996" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <rect
          x="694.309"
          y="477.287"
          width="14.4466"
          height="30.5928"
          fill="#E0E0E1"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M696.367 488.944H706.135V496.746C706.135 497.505 705.519 498.121 704.76 498.121H697.742C696.983 498.121 696.367 497.505 696.367 496.746V488.944Z"
          fill="#FC323A"
        />
        <path
          d="M703.617 489.326C703.617 490.087 703.001 490.704 702.24 490.704L700.265 490.704C699.504 490.704 698.887 490.087 698.887 489.326L698.887 488.937C698.887 487.631 699.946 486.572 701.252 486.572C702.559 486.572 703.617 487.631 703.617 488.937L703.617 489.326Z"
          stroke="#FC323A"
          strokeWidth="1.37467"
        />
        <rect
          x="708.691"
          y="477.287"
          width="5.09879"
          height="30.5928"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="673"
          y="489.184"
          width="18.6956"
          height="18.6956"
          fill="#E0E0E1"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M677.125 495.13H686.892V502.932C686.892 503.691 686.277 504.307 685.518 504.307H678.5C677.74 504.307 677.125 503.691 677.125 502.932V495.13Z"
          fill="#FC323A"
        />
        <path
          d="M684.375 495.512C684.375 496.273 683.758 496.89 682.998 496.89L681.023 496.89C680.262 496.89 679.645 496.273 679.645 495.512L679.645 495.123C679.645 493.817 680.704 492.758 682.01 492.758C683.316 492.758 684.375 493.817 684.375 495.123L684.375 495.512Z"
          stroke="#FC323A"
          strokeWidth="1.37467"
        />
        <rect
          x="691.695"
          y="489.184"
          width="5.94859"
          height="18.6956"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="675.551"
          y="476.389"
          width="10.1976"
          height="13.5968"
          transform="rotate(-20.3501 675.551 476.389)"
          fill="#E0E0E1"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M679.188 480.286L684.998 478.082L686.759 482.724C686.93 483.176 686.703 483.681 686.251 483.852L682.076 485.436C681.624 485.607 681.119 485.38 680.948 484.928L679.188 480.286Z"
          fill="#FC323A"
        />
        <path
          d="M683.586 478.878C683.758 479.331 683.53 479.837 683.077 480.009L681.903 480.454C681.45 480.626 680.944 480.398 680.772 479.946L680.684 479.714C680.39 478.937 680.781 478.068 681.558 477.774C682.335 477.479 683.204 477.87 683.498 478.647L683.586 478.878Z"
          stroke="#FC323A"
          strokeWidth="0.874658"
        />
        <rect
          x="685.109"
          y="472.843"
          width="4.32625"
          height="13.5968"
          transform="rotate(-20.3501 685.109 472.843)"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M739.749 478.488C739.749 479.747 739.386 480.711 738.66 481.381C737.937 482.051 736.892 482.385 735.525 482.385H733.336V474.737H735.763C737.024 474.737 738.004 475.067 738.702 475.726C739.4 476.385 739.749 477.306 739.749 478.488ZM738.047 478.53C738.047 476.887 737.313 476.066 735.847 476.066H734.975V481.046H735.678C737.257 481.046 738.047 480.208 738.047 478.53Z"
          fill="white"
        />
        <path d="M745.846 482.385H741.394V474.737H745.846V476.066H743.033V477.745H745.65V479.074H743.033V481.046H745.846V482.385Z" fill="white" />
        <path d="M747.507 482.385V474.737H749.146V481.046H752.281V482.385H747.507Z" fill="white" />
        <path d="M753.673 482.385V474.737H755.312V482.385H753.673Z" fill="white" />
        <path
          d="M761.71 474.737H763.365L760.737 482.385H758.95L756.328 474.737H757.983L759.436 479.289C759.518 479.557 759.6 479.871 759.685 480.23C759.773 480.586 759.828 480.834 759.849 480.973C759.888 480.652 760.02 480.091 760.245 479.289L761.71 474.737Z"
          fill="white"
        />
        <path d="M768.838 482.385H764.386V474.737H768.838V476.066H766.025V477.745H768.642V479.074H766.025V481.046H768.838V482.385Z" fill="white" />
        <path
          d="M772.138 478.132H772.666C773.185 478.132 773.567 478.047 773.814 477.876C774.06 477.705 774.184 477.437 774.184 477.07C774.184 476.708 774.057 476.45 773.803 476.296C773.553 476.143 773.163 476.066 772.635 476.066H772.138V478.132ZM772.138 479.451V482.385H770.499V474.737H772.751C773.801 474.737 774.579 474.927 775.083 475.308C775.587 475.684 775.839 476.258 775.839 477.029C775.839 477.479 775.714 477.88 775.463 478.232C775.213 478.581 774.859 478.854 774.401 479.053C775.564 480.773 776.322 481.883 776.674 482.385H774.855L773.01 479.451H772.138Z"
          fill="white"
        />
        <path
          d="M780.096 477.887L781.708 474.737H783.474L780.91 479.409V482.385H779.281V479.461L776.717 474.737H778.494L780.096 477.887Z"
          fill="white"
        />
        <path d="M734.188 471.338H759.257" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M730.789 467.939H739.712" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M776.676 489.184H785.599" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M757.98 485.785H783.05" stroke="white" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M612.613 471.783C614.728 471.783 616.442 470.095 616.442 468.013C616.442 465.931 614.728 464.243 612.613 464.243C610.499 464.243 608.785 465.931 608.785 468.013C608.785 470.095 610.499 471.783 612.613 471.783Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M613.891 499.922L613.253 488.72H611.976L611.338 500.028V500.132C611.325 500.379 611.263 500.622 611.154 500.846C611.046 501.069 610.893 501.27 610.706 501.436C610.519 501.601 610.3 501.729 610.062 501.811C609.825 501.894 609.573 501.929 609.322 501.915C608.819 501.871 608.352 501.641 608.016 501.271C607.68 500.901 607.499 500.418 607.51 499.922V487.086C607.177 488.011 606.677 488.72 605.736 488.72C604.777 488.72 604 487.943 604 486.984V478.353C604 476.444 605.547 474.897 607.456 474.897H617.362C618.552 474.897 619.623 475.595 620.251 476.604C621.46 478.549 623.402 480.978 625.569 482.295C626.431 482.818 626.957 483.883 626.577 484.817C626.255 485.61 625.386 486.039 624.618 485.661C622.73 484.733 620.224 482.815 617.719 479.607V500.132C617.706 500.379 617.643 500.622 617.535 500.846C617.426 501.069 617.274 501.27 617.086 501.436C616.899 501.601 616.68 501.729 616.443 501.811C616.205 501.894 615.953 501.929 615.702 501.915C615.2 501.871 614.733 501.641 614.396 501.271C614.06 500.901 613.879 500.418 613.891 499.922Z"
          fill="#FEDB55"
        />
        <path d="M616.37 477.303L615.437 480.739H612.934L613.868 477.304L616.37 477.303Z" fill="#060e4d" />
        <path d="M615.106 479.322V479.723H614.997V479.322H614.781V480.304H614.997V479.888H615.106V480.304H615.322V479.322H615.106Z" fill="white" />
        <path
          d="M613.81 479.689V479.526C613.81 479.505 613.792 479.488 613.771 479.488H613.748C613.726 479.488 613.709 479.505 613.709 479.526V480.098C613.709 480.119 613.726 480.136 613.748 480.136H613.771C613.792 480.136 613.81 480.119 613.81 480.098V479.928H614.027V480.153C614.027 480.236 613.958 480.304 613.873 480.304H613.646C613.561 480.304 613.492 480.236 613.492 480.153V479.473C613.492 479.39 613.561 479.322 613.646 479.322H613.873C613.958 479.322 614.027 479.39 614.027 479.473V479.689H613.81Z"
          fill="white"
        />
        <path
          d="M614.525 479.322H614.145V480.304H614.361V480.043H614.525C614.61 480.043 614.679 479.975 614.679 479.891V479.473C614.679 479.39 614.61 479.322 614.525 479.322ZM614.463 479.839C614.463 479.86 614.445 479.877 614.424 479.877H614.361V479.488H614.424C614.445 479.488 614.463 479.505 614.463 479.526V479.839Z"
          fill="white"
        />
        <path
          d="M613.253 488.72L613.891 499.922C613.88 500.418 614.061 500.901 614.397 501.271C614.734 501.641 615.2 501.872 615.703 501.915C615.954 501.929 616.206 501.894 616.444 501.811C616.681 501.729 616.9 501.601 617.087 501.436C617.275 501.27 617.427 501.069 617.535 500.846C617.644 500.622 617.707 500.379 617.72 500.132V485.551H607.438V487.279C607.463 487.216 607.487 487.151 607.511 487.086V499.922C607.5 500.418 607.68 500.901 608.017 501.271C608.353 501.641 608.82 501.872 609.322 501.915C609.574 501.929 609.826 501.894 610.063 501.811C610.301 501.729 610.519 501.601 610.707 501.436C610.894 501.27 611.046 501.069 611.155 500.846C611.263 500.622 611.326 500.379 611.339 500.132V500.028L611.977 488.72H613.253Z"
          fill="#FFDD66"
        />
        <path
          d="M607.51 478.697V499.952C607.499 500.449 607.68 500.931 608.016 501.301C608.352 501.671 608.819 501.902 609.322 501.946C609.573 501.959 609.825 501.924 610.062 501.842C610.3 501.759 610.519 501.632 610.706 501.466C610.893 501.3 611.046 501.1 611.154 500.876C611.263 500.652 611.325 500.409 611.338 500.162C611.338 500.127 611.338 500.093 611.338 500.058L611.976 488.751H613.253L613.891 499.952C613.879 500.449 614.06 500.931 614.396 501.301C614.733 501.671 615.2 501.902 615.702 501.946C615.953 501.959 616.205 501.924 616.443 501.842C616.68 501.759 616.899 501.632 617.086 501.466C617.274 501.3 617.426 501.1 617.535 500.876C617.643 500.652 617.706 500.409 617.719 500.162C617.719 500.127 617.719 500.093 617.719 500.058V479.637C620.224 482.845 622.73 484.763 624.618 485.691C625.386 486.069 626.255 485.64 626.577 484.847V484.847C626.957 483.913 626.431 482.848 625.569 482.325C623.402 481.008 621.46 478.579 620.251 476.635C619.623 475.625 618.552 474.927 617.362 474.927L607.456 474.927C605.547 474.927 604 476.474 604 478.383V487.014C604 487.973 604.777 488.751 605.736 488.751V488.751C606.692 488.751 607.468 487.978 607.472 487.022L607.509 479.011"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M608.125 485.551H617.06" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" />
        <path
          d="M623.738 481.427H637.878L636.994 502.047H624.622L623.738 481.427Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip4_4073_32864)">
          <path
            d="M629.028 491.264L629.671 491.677L629.336 489.826L627.514 490.289L628.161 490.706L626.761 492.895C626.659 493.054 626.653 493.255 626.743 493.421C626.833 493.586 627.007 493.688 627.195 493.688H629.773V492.657H628.137L629.028 491.264Z"
            fill="#060e4d"
          />
          <path
            d="M634.848 492.896L633.536 490.834L632.666 491.388L633.474 492.657H631.578V491.884L630.289 493.173L631.578 494.462V493.688H634.413C634.601 493.688 634.774 493.586 634.865 493.421C634.956 493.256 634.949 493.055 634.848 492.896Z"
            fill="#060e4d"
          />
          <path
            d="M631.605 489.727L630.952 490.121L632.761 490.636L633.147 488.795L632.487 489.194L631.237 487.226C631.142 487.077 630.978 486.987 630.802 486.987C630.626 486.987 630.462 487.077 630.367 487.225L629.219 489.03L630.089 489.583L630.802 488.463L631.605 489.727Z"
            fill="#060e4d"
          />
        </g>
        <rect x="622.559" y="479.07" width="16.4961" height="2.35658" fill="#FFDD66" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <rect x="624.914" y="477.303" width="11.7829" height="1.76744" fill="#FFDD66" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path
          d="M323.332 508.68V465.966C323.332 464.635 322.253 463.556 320.922 463.556H150.035C148.752 463.556 147.694 464.56 147.627 465.841L145.999 497.188V513.506C145.999 514.471 146.574 515.342 147.46 515.722L151.659 517.522C151.959 517.65 152.282 517.716 152.609 517.716H312.455C312.993 517.716 313.516 517.536 313.941 517.204L322.407 510.578C322.991 510.121 323.332 509.421 323.332 508.68Z"
          fill="#FEDB55"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M146 497.188H183.738C184.706 497.188 185.595 496.654 186.05 495.8L188.065 492.023C188.52 491.17 189.409 490.636 190.377 490.636H323.333V466.176C323.333 464.729 322.16 463.556 320.712 463.556H150.235C148.841 463.556 147.69 464.648 147.618 466.04L146 497.188Z"
          fill="#C4D1E8"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M149.492 485.185C149.492 483.853 150.571 482.774 151.903 482.774L155.607 482.774V499.372H151.903C150.571 499.372 149.492 498.293 149.492 496.961V485.185Z"
          fill="#4E76BB"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path d="M189.68 463.556V490.636" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M220.254 463.556V490.636" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M250.828 463.556V490.636" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M281.402 463.556V490.636" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M311.977 463.556V490.636" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M155.609 501.992L155.609 512.475" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M159.105 501.992L159.105 512.475" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M162.598 501.992L162.598 512.475" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M166.09 501.992L166.09 512.475" stroke="#060e4d" strokeWidth="1.37467" strokeLinecap="round" strokeLinejoin="round" />
        <ellipse cx="189.679" cy="515.969" rx="9.60918" ry="9.60918" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <circle cx="189.681" cy="515.969" r="1.74712" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <ellipse cx="292.758" cy="515.97" rx="9.60917" ry="9.60918" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <ellipse cx="292.759" cy="515.97" rx="1.74713" ry="1.74712" fill="white" stroke="#060e4d" strokeWidth="1.37467" strokeLinejoin="round" />
        <path d="M232.483 490.636L225.13 517.716H205.402L212.765 490.648L232.483 490.636Z" fill="#060e4d" />
        <path d="M222.505 506.549V509.706H221.653V506.549H219.949V514.287H221.653V511.01H222.505V514.287H224.209V506.549H222.505Z" fill="white" />
        <path
          d="M212.299 509.439V508.156C212.299 507.989 212.161 507.853 211.992 507.853H211.811C211.641 507.853 211.503 507.989 211.503 508.156V512.661C211.503 512.828 211.641 512.964 211.811 512.964H211.992C212.161 512.964 212.299 512.828 212.299 512.661V511.318H214.008V513.09C214.008 513.75 213.466 514.285 212.798 514.285H211.007C210.339 514.285 209.797 513.75 209.797 513.09V507.738C209.797 507.079 210.339 506.544 211.007 506.544H212.798C213.466 506.544 214.008 507.079 214.008 507.738V509.439H212.299Z"
          fill="white"
        />
        <path
          d="M217.927 506.544H214.926V514.285H216.63V512.223H217.927C218.595 512.223 219.135 511.688 219.135 511.027V507.738C219.135 507.079 218.595 506.544 217.927 506.544ZM217.433 510.619C217.433 510.788 217.295 510.922 217.126 510.922H216.63V507.853H217.126C217.295 507.853 217.433 507.989 217.433 508.156V510.619Z"
          fill="white"
        />
        <g clipPath="url(#clip5_4073_32864)">
          <path d="M271.435 482.801H266.28L261.812 485.55V490.705H275.559V485.55L271.435 482.801Z" fill="#4E76BB" />
          <path
            d="M266.484 482.394L262.48 484.806C262.066 485.055 261.812 485.502 261.812 485.985V490.706H275.559V485.985C275.559 485.502 275.306 485.054 274.892 484.806L270.888 482.394"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M272.812 477.719C271.465 477.719 270.239 477.164 269.365 476.271C268.492 477.164 267.276 477.719 265.929 477.719C265.454 477.719 264.999 477.634 264.566 477.506"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M264.562 477.646C264.562 475.368 266.409 473.522 268.687 473.522C270.964 473.522 272.811 475.368 272.811 477.646C272.811 481.083 270.964 483.145 268.687 483.145C266.409 483.145 264.562 481.083 264.562 477.646Z"
            fill="white"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g clipPath="url(#clip6_4073_32864)">
          <path
            d="M169.884 496.396L164.172 501.528C163.985 501.697 163.835 501.904 163.733 502.134C163.631 502.365 163.578 502.614 163.578 502.866V509.473C163.578 509.951 163.768 510.409 164.106 510.747C164.444 511.085 164.902 511.274 165.38 511.274C165.858 511.274 166.316 511.085 166.654 510.747C166.992 510.409 167.182 509.951 167.182 509.473V503.669L171.32 501.285"
            fill="#FFDD66"
          />
          <path
            d="M169.884 496.396L164.172 501.528C163.985 501.697 163.835 501.904 163.733 502.134C163.631 502.365 163.578 502.614 163.578 502.866V509.473C163.578 509.951 163.768 510.409 164.106 510.747C164.444 511.085 164.902 511.274 165.38 511.274C165.858 511.274 166.316 511.085 166.654 510.747C166.992 510.409 167.182 509.951 167.182 509.473V503.669L171.32 501.285"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.682 483.047C166.526 483.047 164.778 481.3 164.778 479.144C164.778 476.988 166.526 475.24 168.682 475.24C170.838 475.24 172.586 476.988 172.586 479.144C172.586 481.3 170.838 483.047 168.682 483.047Z"
            fill="white"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M169.023 479.614C167.373 478.514 166.732 476.407 166.617 475.49C169.367 473.772 172.803 474.459 174.178 477.208C175.278 479.408 174.407 483.165 173.834 484.769H169.367C169.939 483.509 170.672 480.714 169.023 479.614Z"
            fill="#C4D1E8"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M157.026 491.018C157.083 490.789 157.185 490.573 157.326 490.383C157.467 490.192 157.644 490.032 157.846 489.91C158.049 489.788 158.274 489.708 158.508 489.673C158.742 489.638 158.981 489.65 159.21 489.707L163.368 490.747L169.113 486.107C169.579 485.758 170.129 485.539 170.707 485.472C171.286 485.405 171.872 485.492 172.406 485.724C172.939 485.957 173.402 486.326 173.747 486.796C174.091 487.265 174.306 487.817 174.368 488.396L177.36 509.172C177.438 509.622 177.342 510.084 177.091 510.465C176.84 510.847 176.454 511.118 176.01 511.224C175.566 511.33 175.099 511.264 174.703 511.037C174.306 510.811 174.011 510.443 173.877 510.007L168.512 491.708L164.643 494.05C164.372 494.214 164.071 494.322 163.758 494.369C163.445 494.416 163.126 494.401 162.819 494.324L158.337 493.203C158.108 493.146 157.891 493.044 157.701 492.903C157.511 492.762 157.351 492.585 157.229 492.382C157.107 492.179 157.026 491.955 156.991 491.72C156.957 491.486 156.968 491.248 157.026 491.018Z"
            fill="#FEDB55"
            stroke="#060e4d"
            strokeWidth="1.37467"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M27.3723 483.434C27.009 481.617 24.1393 477.692 20.6521 479.437C17.1648 481.181 17.4434 483.797 17.9277 485.251C17.2617 484.524 15.6392 483.288 14.4768 484.161C13.4439 484.936 13.8642 486.916 14.3105 488.112C13.2291 485.636 10.2061 481.74 5.39541 483.252C0.309841 484.851 2.18666 489.611 3.76077 491.792C2.671 490.58 -0.0170898 488.776 -2.05132 491.247C-3.01431 492.416 -3.39117 493.551 -3.46324 494.511C-4.13269 492.617 -5.51713 490.881 -8.04503 491.792C-11.6776 493.1 -10.6484 496.455 -9.67968 497.969C-10.83 497.121 -13.2759 495.934 -13.8571 497.969C-14.4383 500.004 -13.1306 502.209 -12.4041 503.057H40.8128C42.7502 501.361 45.6804 497.134 41.9026 493.79C38.513 490.791 36.1372 490.98 35.1161 491.575C36.5331 490.498 38.627 488.284 37.5434 486.523C36.381 484.633 33.4265 485.735 32.0946 486.523C33.1844 485.009 32.6758 483.398 31.3681 482.525C30.0604 481.653 28.0988 482.707 27.3723 483.434Z"
          fill="#799E92"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M1061.61 418.339C1068.51 414.446 1073.79 419.961 1075.57 423.206C1078.45 420.908 1085.1 417.122 1088.72 420.367C1092.33 423.611 1089.67 429.019 1087.89 431.317C1089.26 429.695 1093.32 428.235 1098.57 435.373C1103.83 442.511 1098.02 448.621 1094.47 450.784C1101.04 457.273 1098.57 468.629 1092 472.685C1086.74 475.929 1078.86 471.333 1075.57 468.629C1074.75 470.792 1071.63 474.875 1065.71 473.902C1059.8 472.928 1059.14 469.17 1059.55 467.412C1057.64 468.9 1053.06 471.387 1050.11 469.44C1047.15 467.494 1048.88 462.681 1050.11 460.518C1046.27 461.464 1038.03 461.491 1035.73 454.029C1033.43 446.566 1042.99 442.538 1048.05 441.456C1046 440.78 1042.39 438.05 1044.36 432.534C1046.33 427.018 1052.03 428.613 1054.63 430.1C1054.08 427.802 1054.71 422.233 1061.61 418.339Z"
          fill="#799E92"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M1073.87 505.667L1072.09 460.99H1068.09L1066.31 505.667H1073.87Z"
          fill="#9D8B67"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <ellipse cx="1069.75" cy="455.491" rx="8.24805" ry="6.87337" fill="#799E92" />
        <path
          d="M1064.25 460.302C1064.9 462.069 1068.14 464.788 1075.93 461.526"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-179.047 621.076C-177.183 611.732 -162.459 591.548 -144.566 600.519C-126.673 609.489 -128.102 622.945 -130.587 630.42C-127.17 626.683 -118.845 620.329 -112.881 624.814C-107.581 628.799 -109.737 638.982 -112.027 645.135C-106.479 632.401 -90.9681 612.363 -66.2846 620.142C-40.1908 628.365 -49.8206 652.847 -57.8973 664.06C-52.3058 657.83 -38.5133 648.548 -28.0758 661.256C-23.1348 667.272 -21.2011 673.107 -20.8313 678.046C-17.3964 668.302 -10.2929 659.378 2.67764 664.06C21.3161 670.788 16.0352 688.043 11.065 695.83C16.9671 691.47 29.517 685.365 32.4992 695.83C35.4813 706.296 28.7715 717.633 25.0438 721.994H-248.009C-257.95 713.273 -272.985 691.532 -253.601 674.338C-236.21 658.912 -224.019 659.884 -218.78 662.946C-226.05 657.407 -236.794 646.02 -231.235 636.961C-225.27 627.243 -210.111 632.912 -203.277 636.961C-208.868 629.174 -206.259 620.889 -199.549 616.404C-192.839 611.919 -182.775 617.338 -179.047 621.076Z"
          fill="#A3C797"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinejoin="round"
        />
        <path
          d="M1061.87 567.743C1069.04 576.658 1083.11 572.165 1089.25 568.804C1093.12 571.634 1103.58 576.87 1114.53 575.172C1125.48 573.474 1122.25 560.667 1119.27 554.476C1128.92 551.823 1148.22 541.74 1148.22 522.636C1148.22 503.532 1126.46 500.524 1115.58 501.409C1116.11 494.687 1112.42 480.5 1093.47 477.529C1074.51 474.557 1071.18 489.38 1071.88 497.163C1064.33 496.987 1047.87 500.56 1042.39 516.268C1036.92 531.975 1048.89 541.209 1055.56 543.862C1054.68 548.108 1054.71 558.827 1061.87 567.743Z"
          fill="#687D61"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1070.24 542.078V545.252L1086.72 550.013L1085.13 625.128H1097.89L1095.76 552.658L1112.78 534.673L1129.79 533.615L1131.39 530.441H1114.37L1120.75 522.506L1117.56 521.448L1095.76 543.665L1094.7 526.738H1088.32L1087.79 545.252L1070.24 542.078Z"
          fill="#CCB58A"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M208.025 482.802H202.87L198.402 485.551V490.706H212.149V485.551L208.025 482.802Z" fill="#4E76BB" />
        <path
          d="M203.073 482.394L199.07 484.807C198.656 485.055 198.402 485.503 198.402 485.985V490.706H212.149V485.985C212.149 485.502 211.895 485.055 211.482 484.807L207.478 482.394"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M201.152 477.646C201.152 475.369 202.999 473.522 205.276 473.522C207.554 473.522 209.4 475.369 209.4 477.646C209.4 481.083 207.554 483.145 205.276 483.145C202.999 483.145 201.152 481.083 201.152 477.646Z"
          fill="white"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M209.402 477.72C208.054 477.72 206.829 477.164 205.955 476.272C205.082 477.164 203.866 477.72 202.519 477.72C202.044 477.72 201.589 477.634 201.156 477.506"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M201.152 477.646C201.152 477.646 201.152 480.396 198.402 482.458C198.982 483.872 200.293 484.07 200.293 484.07"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M209.355 477.646C209.355 477.646 209.355 480.396 212.105 482.458C211.525 483.872 210.214 484.07 210.214 484.07"
          stroke="#060e4d"
          strokeWidth="1.37467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4073_32864">
          <rect width="1110" height="624" fill="white" />
        </clipPath>
        <clipPath id="clip1_4073_32864">
          <rect width="270.257" height="36.6364" fill="white" transform="translate(-55.2578 402.504)" />
        </clipPath>
        <clipPath id="clip2_4073_32864">
          <rect width="27.8212" height="27.7829" fill="white" transform="translate(542.164 471.55)" />
        </clipPath>
        <clipPath id="clip3_4073_32864">
          <rect width="10.9974" height="10.9974" fill="white" transform="translate(950.66 490.362) rotate(-90)" />
        </clipPath>
        <clipPath id="clip4_4073_32864">
          <rect width="8.24805" height="8.24804" fill="white" transform="translate(626.684 486.729)" />
        </clipPath>
        <clipPath id="clip5_4073_32864">
          <rect width="20.9655" height="20.9655" fill="white" transform="translate(255.191 468.797)" />
        </clipPath>
        <clipPath id="clip6_4073_32864">
          <rect width="38.4909" height="23.3695" fill="white" transform="matrix(-1 0 0 1 188.613 473.178)" />
        </clipPath>
      </defs>
    </svg>
  )
}
